import { ImgLite } from "@avantstay/img-lite"
import styled from "@emotion/styled"

import { Link as CoreLink } from "components/core/Link"
import { minTabletMediaQuery } from "theme/media-queries"
import { rgba } from "utils/cssUtils"

export const Container = styled.div`
  max-width: 1024px;
  margin: 0 auto 60px;
  position: relative;

  ${minTabletMediaQuery} {
    margin-bottom: 120px;
  }
`

export const Category = styled.p`
  ${p => p.theme.typography.standard.size_16px.semibold()}
  color: ${p => p.theme.colors.accentMedium};
  line-height: 1.54;
  margin: 0;

  ${minTabletMediaQuery} {
    ${p => p.theme.typography.standard.size_18px.semibold()}
    max-width: 745px;
  }
`

export const Title = styled.h2`
  ${p => p.theme.typography.special.size_24px.bold()}
  color: ${p => p.theme.colors.primaryMedium};
  line-height: 1.4;
  width: auto;
  margin: 10px 0 14px;

  ${minTabletMediaQuery} {
    ${p => p.theme.typography.special.size_32px.bold()}
    margin: 8px 160px 12px 0;
  }
`

export const Date = styled.p`
  ${p => p.theme.typography.standard.size_16px.normal()}
  color: ${p => rgba(p.theme.colors.primaryMedium, 0.7)};
  line-height: 1.54;
  margin: 0;

  ${minTabletMediaQuery} {
    ${p => p.theme.typography.standard.size_18px.normal()}
  }
`

export const FeaturedImage = styled(ImgLite)`
  width: 100%;
  height: 20vh;
  min-height: 300px;
  margin: 20px auto;
  background-color: ${p => p.theme.colors.primaryExtremelyLight};

  ${minTabletMediaQuery} {
    height: 537px;
    margin: 30px auto;
  }
`

export const Content = styled.div`
  ${p => p.theme.typography.standard.size_18px.normal()}
  color: ${p => p.theme.colors.neutralExtraDark};
  line-height: 1.5;
  margin: 0;

  a {
    display: none;
  }

  ${minTabletMediaQuery} {
    ${p => p.theme.typography.standard.size_24px.normal()}
  }
`
export const Link = styled(CoreLink)`
  text-decoration: none;

  :hover {
    opacity: 0.8;
  }

  :visited {
    color: ${p => p.theme.colors.primaryMedium};
  }
`
